import styled, { css } from "styled-components";
import SportIcons from "images/sports/common/sp_layout.png";

export const Wrap = styled.div`
  background-color: #fff;
`;

export const Tab = styled.div`
  padding: 0px 30px 30px 30px;
  border-bottom: 1px solid #e3e3e3;
  > div {
    display: flex;
    height: 50px;
    border: 1px solid #78818e;
  }
`;

export const TabButton = styled.button`
  flex: 1;
  height: 100%;
  background-color: #78818e;
  color: #fff;
  font-size: 12px;
  ${(props) =>
    props.active &&
    css`
      background-color: #fff;
      color: #373f4c;
    `}
  :disabled {
    color: rgba(255, 255, 255, 0.3);
  }
`;

export const ListWrapper = styled.div`
  width: 100%;
`;
export const List = styled.ul`
  &:last-child > li:last-child {
    border-bottom: none;
  }
`;

export const ListItem = styled.li`
  height: auto;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0 30px;

  border-bottom: 1px solid rgb(236, 239, 243);
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 14px 0;
`;

export const TextWrapper = styled.p`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const Text = styled.p`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  line-height: 23px;
  color: #333;
  & > em {
    color: #999;
  }
`;

export const DisplayTime = styled.div`
  padding-top: 20px;
  width: 65px;
  height: auto;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  color: #333;
`;

export const TeamLogo = styled.div`
  width: 23px;
  height: 23px;
  margin-right: 12px;
`;

export const Event = styled.div`
  height: 15px;
  display: flex;
  flex-wrap: nowrap;
  margin-right: 12px;

  & > em {
    display: inline-block;
    margin: 2px 5px 0 0;
    width: 15px;
    height: 15px;
    vertical-align: top;
    background: url(${SportIcons}) no-repeat 100px -100px;
    background-size: 350px 350px;
  }
  & > em.goal {
    background-position: -105px -310px;
  }
  & > em.no_goal {
    background-position: -125px -310px;
  }
`;
